import React from 'react';
import { GamePage } from './pages/GamePage';
export function App() {
  return <GamePage data-id="element-0" />;
}